/** Build a read-only summary of the portfolio already loaded from localStorage. */
export function createPortfolioSnapshot(portfolio) {
  const holdings = Array.isArray(portfolio) ? portfolio : [];

  return {
    holdings,
    holdingCount: holdings.length,
    totalQuantity: holdings.reduce((total, holding) => {
      const quantity = Number.parseFloat(holding?.quantity);
      return total + (Number.isFinite(quantity) ? quantity : 0);
    }, 0),
    dividendCount: holdings.reduce(
      (total, holding) =>
        total + (Array.isArray(holding?.dividends) ? holding.dividends.length : 0),
      0
    ),
  };
}
